import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import InlineSelectComponent from "../../common/inline-edit/component/InlineSelectComponent"
import { GlobalHelper } from "../../indexImports"
import IntlProps from "../../state/helpers/IntlProps"
import { SelectOption } from "../../state/helpers/SelectOption"
import Label from "../../state/label/Label"
import LabelService from "../../state/label/LabelService"
import { TYPE_CUSTOMER } from "../../state/label/labelTypes"
import priceListMessages from "../helpers/priceListMessages"

type OwnProps = {
    customerType: string
    onCustomerTypeChange: (string, actionId) => void
}
const CustomerTypeSelectComponent = (props: OwnProps & IntlProps) => {
    const [labels, setLabels] = useState<Label[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        (async () => {
            const labels = await LabelService.getLabelsOf(TYPE_CUSTOMER)
            setLabels(labels as Label[])
            setIsLoading(false)
        })()
    }, [])

    const defaultOption: SelectOption =
        { label: props.intl.formatMessage(priceListMessages["customer-type-all"]), value: "" }
    const options = [defaultOption, ...createOptions(labels)]
    const selectedOption = options.find(x => x.value == props.customerType) || options[0]

    return (
        <>
            { !GlobalHelper.hasGolfIntegration() &&
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="price_list.edit.details.customer_type_label"
                        defaultMessage="Allowed Customer Type"
                    />
                </label>
            }
            <div className="col-12">
                {!isLoading && !GlobalHelper.hasGolfIntegration() &&
                    <InlineSelectComponent
                        title={selectedOption.label as string}
                        name="price-list-customer-type-select"
                        id="price-list-customer-type-select"
                        value={selectedOption}
                        onChange={(option, actionId) => props.onCustomerTypeChange(option.value, actionId)}
                        options={options}
                    />
                }
            </div>

        </>
    )
}

function createOptions(customerTypes: Label[]): SelectOption[] {
    return customerTypes.map(l => ({ label: l.getTitle(), value: l.getTitle() }))
}

export default injectIntl(CustomerTypeSelectComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/CustomerTypeSelectComponent.tsx